import borrowerTypes from './borrowerTypes'

/**
 * Returns an object for each provided entity with a numbered title (borrower type), name, and key (__typename + rid)
 * For example:
 *  {
 *    name: 'Business Corp',
 *    title: 'OC',
 *    key: 'Business43'
 *  }
 * @param   {object[]} entities An array of entities whose names will be formatted to include their borrowerType
 * @returns {object[]}
 */
export default entities => {
  const borrowerTypeCounts = {}
  for (const entity of entities) {
    const { __typename, borrowerType } = entity
    const numberOfType = borrowerTypeCounts[borrowerType]
    if (__typename === 'Business' && !numberOfType) {
      borrowerTypeCounts[borrowerType] = 0
    }
  }
  return entities.map(entity => {
    const { __typename, borrowerType, name, rid } = entity
    let bType
    if (__typename === 'Business') {
      borrowerTypeCounts[borrowerType] += 1
    }
    if (borrowerType) {
      if (borrowerType !== 'oc') {
        bType = `${borrowerTypes[borrowerType]} ${borrowerTypeCounts[borrowerType]}`
      } else if (borrowerType === 'oc') {
        bType = 'OC'
      }
    }
    return {
      title: bType,
      name,
      key: `${__typename}${rid}`
    }
  })
}
